import { ROUTES } from "app/helpers/routerPathHelper";
import { SessionHelper } from "app/helpers/sessionHelper";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";

interface SelfExclusionFormProps {
  hideForm: boolean;
  handleSelectChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  error: string;
  disabled: boolean;
  handleDisplayConfirmationMessage: () => void;
  selfExclusionTimePeriod?: string;
}

const SelfExclusionForm: React.FC<SelfExclusionFormProps> = ({
  hideForm,
  handleSelectChange,
  error,
  disabled,
  handleDisplayConfirmationMessage,
  selfExclusionTimePeriod,
}) => {
  const history = useHistory();
  const dropDownOptions = [
    {
      value: "default",
      messageId: "settings-self-exclusion-select-time-period",
    },
    {
      value: "sixMonths",
      messageId: "settings-self-exclusion-option-6-months",
    },
    { value: "oneYear", messageId: "settings-self-exclusion-option-1-year" },
    { value: "fiveYears", messageId: "settings-self-exclusion-option-5-years" },
    {
      value: "permanent",
      messageId: "settings-self-exclusion-option-permanent",
    },
  ];

  const handleRedirect = (
    e: React.MouseEvent<HTMLSpanElement>,
    path: string
  ) => {
    e.preventDefault();

    const isAsianRoute = SessionHelper.isAsianRouteAndSessionView();

    const selfExclusionRoute = isAsianRoute
      ? ROUTES.asianHelpAndLearningSelfExclusion
      : ROUTES.helpAndLearningSelfExclusion;

    const responsibleGamblingRoute = isAsianRoute
      ? ROUTES.asianHelpAndLearningResponsibleGaming
      : ROUTES.helpAndLearningResponsibleGaming;

    history.push(
      path === "selfexclusion" ? selfExclusionRoute : responsibleGamblingRoute
    );
  };

  return (
    <form
      id={"self-exclusion__form"}
      className={`self-exclusion__form ${hideForm ? "hide" : ""}`}
    >
      <h2 className="self-exclusion__title">
        <FormattedMessage id="settings-self-exclusion" />
      </h2>
      <label>
        <select
          className="self-exclusion-selection"
          onChange={handleSelectChange}
          defaultValue={dropDownOptions[0].value}
          value={selfExclusionTimePeriod}
        >
          {dropDownOptions.map(option => (
            <option key={option.value} value={option.value}>
              <FormattedMessage tagName="span" id={option.messageId} />
            </option>
          ))}
        </select>
        <div className="error-message">{error}</div>
      </label>
      <button
        type="button"
        disabled={disabled}
        onClick={handleDisplayConfirmationMessage}
      >
        <FormattedMessage tagName="span" id="settings-apply-self-exclusion" />
      </button>
      <div className="responsible-gaming__text">
        <FormattedMessage
          tagName="span"
          id="settings-responsible-gambling-text"
        />

        <span
          className="responsible-gaming__link"
          onClick={e => handleRedirect(e, "responsiblegaming")}
        >
          <FormattedMessage
            tagName="span"
            id="settings-responsible-gambling-link"
          />
        </span>
      </div>
      <div className="responsible-gaming__text">
        <FormattedMessage
          tagName="span"
          id="settings-self-exclusion-policy-text"
        />

        <span
          className="responsible-gaming__link self-exclusion__text"
          onClick={e => handleRedirect(e, "selfexclusion")}
        >
          <FormattedMessage
            tagName="span"
            id="settings-self-exclusion-policy-link"
          />
        </span>
      </div>
    </form>
  );
};

export default SelfExclusionForm;
